import React, { Fragment } from 'react';

/* Utilities */
import { currency } from 'js/utilities';

export default function ConversionFlowSummary({ summary, vehicle, cart }) {
    const price = vehicle?.conversion_vehicle_price ?? vehicle?.partner_vehicle_price ?? vehicle?.price;
    const hasCartProducts = summary?.cart?.products && summary?.cart?.products.length > 0;

    return (
        <>
            {Object.keys(summary?.categories || {})?.length > 0 && (
                <div className="row gutters-0">
                    {Object.entries(summary?.categories || {})?.map(([key, category]) => (
                        <div key={key} className="col-12">
                            <div className="row row--bordered gutters-2 mb-1" key={key}>
                                <div className="col-12">
                                    <p className="mb-0 font-weight-extra-bold text-base">1. Voertuig</p>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <p className="mb-0 text--16">{vehicle?.brand} {vehicle?.model}</p>
                                        <p className="mb-0 text-base text--16 font-weight-extra-bold">{price ? currency(price) : '-'}</p>
                                    </div>
                                    <p className="text--14 mb-0">
                                        {vehicle?.type?.length > 25 ?
                                            `${vehicle?.type.substring(0, 25)}...` : vehicle?.type
                                        }
                                    </p>
                                </div>
                                {hasCartProducts && (
                                    <>
                                        <div className="col-12">
                                            <p className="mb-0 font-weight-extra-bold text-base">2. Accessoires</p>
                                            <div className="row gutters-2 align-items-center justify-content-between">
                                                {summary?.cart?.products.map((product, index) => (
                                                    <Fragment key={index}>
                                                        <div className="col-6">
                                                            <div className="info">
                                                                <p className="text--16 text-base mb-0">{product.label}</p>
                                                                <p className="text--14 mb-0">{product.productNumber}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            <p className="text--16 font-weight-extra-bold mb-0 text-base">{currency(product.price)}</p>
                                                        </div>
                                                    </Fragment>
                                                ))}
                                            </div>
                                        </div>
                                    </>
                                )}

                                {Object.entries(category?.values || {}).map(([key, value], index) => {
                                    const summaryIndex = index + (hasCartProducts ? 3 : 2);

                                    if (
                                        value &&
                                        typeof value === 'object' &&
                                        !Array.isArray(value.value) &&
                                        typeof value.value === 'object' &&
                                        value.value !== null
                                    ) {
                                        return (
                                            <div className="col-12" key={index}>
                                                <p className="mb-0 font-weight-extra-bold text-base">{summaryIndex}. {value.label}</p>
                                                <div className="row gutters-2 align-items-center justify-content-between">
                                                    {Object.entries(value.value).map(([subKey, subValue], subIndex) => (
                                                        <Fragment key={subIndex}>
                                                            <div className="col-6">
                                                                <p className="text--16 text-base mb-0">{subValue.label}</p>
                                                            </div>
                                                            <div className="col-6 text-right">
                                                                <p className="text--16 font-weight-extra-bold mb-0 text-base">{subValue.value}</p>
                                                            </div>
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    }

                                    // Accessoires als array van objecten
                                    if (key === 'Accessoires' && Array.isArray(value)) {
                                        return (
                                            <div className="col-12" key={index}>
                                                <p className="mb-0 font-weight-extra-bold text-base">{summaryIndex}. {key}</p>
                                                <div className="row gutters-2 align-items-center justify-content-between">
                                                    {value.map((accessory, idx) => (
                                                        <Fragment key={idx}>
                                                            <div className="col-6">
                                                                <div className="info">
                                                                    <p className="text--16 text-base mb-0">{accessory.label}</p>
                                                                    <p className="text--14  mb-0">{accessory.number}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-6 text-right">
                                                                <p className="text--16 font-weight-extra-bold mb-0 text-base">{currency(accessory.value)}</p>
                                                            </div>
                                                        </Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        );
                                    }

                                    // Default rendering
                                    return (
                                        <Fragment key={index}>
                                            {index === 0 && !hasCartProducts && <hr className="w-100 mt-2 mb-0" />}

                                            <div className="col-12">
                                                <p className="mb-0 font-weight-extra-bold text-base">{summaryIndex}. {key}</p>
                                                <div className="row gutters-2 align-items-center justify-content-between">
                                                    <div className="col-6">
                                                        <p className="text--16 text-base mb-0">{value?.label}</p>
                                                    </div>
                                                    <div className="col-6 text-right">
                                                        {typeof value?.value === 'string' ? (
                                                            value.value.split('\n').map((line, i) => (
                                                                <p className="text--16 text-base font-weight-extra-bold mb-0 text-base" key={i}>{line}</p>
                                                            ))
                                                        ) : (
                                                            <p className="text--16 font-weight-extra-bold mb-0 text-base">{value?.value}</p>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                    );
                                })}

                            </div>
                        </div>
                    ))}
                </div>
            )}
        </>
    )
}
